// @flow
import React from 'react';
import './Login.scss';

import Logo from '../assets/images/logos/featureflow-logo-text-150x155.png';

import LoginForm from '../forms/LoginForm';
import SignupForm from '../forms/SignupForm';
import constants from '../config/constants';
import {getHostname, getSubdomain} from "../utils/api";
import { useFeatureflow } from 'react-featureflow-client';

export default function Login(): React.Element<any>{
  const featureflow = useFeatureflow();
  const loginRedirect = featureflow.evaluate('login-redirect').isOn();
  const isAppSubdomain = getSubdomain().toLowerCase() === 'app';
  return (
    <div id="login-container">
      <div id="login">
        <img src={Logo} alt="featureflow"/>
        <div>
          <h1>
            Release confidently.
          </h1>
          <h4>
            Build and release better software faster
          </h4>
        </div>
        <span className={'version'}>{constants.VERSION}</span>
      </div>
      
      {isAppSubdomain ? (
        <div id="sidebar">
          <div className="login-heading">
            <h4>
              It's simple to get started...
            </h4>
          </div>
          <SignupForm/>
        </div>
      ) : (
        <div id="sidebar">
          <div className="login-heading">
            <h4>Login to {getHostname()}</h4>
          </div>
          {loginRedirect ? (
            <div style={{
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              borderRadius: 12,
              padding: '32px 28px',
              marginBottom: 24,
              boxShadow: '0 8px 32px rgba(102, 126, 234, 0.3)',
              textAlign: 'center'
            }}>
              <div style={{
                fontSize: 48,
                marginBottom: 16
              }}>🚀</div>
              <h3 style={{
                color: 'white',
                fontWeight: 600,
                marginBottom: 12,
                fontSize: 22
              }}>
                Featureflow has evolved!
              </h3>
              <p style={{
                color: 'rgba(255, 255, 255, 0.9)',
                fontSize: 16,
                marginBottom: 20,
                lineHeight: 1.5
              }}>
                We've moved to a brand new platform with improved features and performance. Log in with your existing credentials.
              </p>
              <a 
                href="https://app.featureflow.com" 
                style={{
                  display: 'inline-block',
                  background: 'white',
                  color: '#667eea',
                  padding: '12px 28px',
                  borderRadius: 8,
                  fontWeight: 600,
                  fontSize: 16,
                  textDecoration: 'none',
                  boxShadow: '0 4px 14px rgba(0, 0, 0, 0.15)',
                  transition: 'transform 0.2s, box-shadow 0.2s'
                }}
              >
                Go to app.featureflow.com →
              </a>
            </div>
          ) : (<></>)}
          <LoginForm/>
          <div>Not a member? <a href="https://app.featureflow.com/register">Sign up for free</a></div>
        </div>
      )}
    </div>
  )
}
